import React from 'react';
import { Layout } from 'antd';
import useUrlState from '../../hooks/useUrlState';
import Header from '../shared/Header';
import DomainSetupCheck from '../websiteIndexEntry/DomainSetupCheck';
import ClusterUrls from '../serviceableUrls/ClusterUrls';
import { useFetchUrlClustersQuery } from '../urlClusters/service';
import { skipToken } from '@reduxjs/toolkit/query/react';
import UrlClusterHeaderActions from '../urlClusters/UrlClusterHeaderActions';
import ClusterFailedChecks from '../failedChecks/ClusterFailedChecks';
import useScrollToTop from '../../hooks/useScrollToTop';

const { Content } = Layout;

export default function UrlClusterPage() {
    useScrollToTop();

    const [urlState] = useUrlState();
    const { w_guid: websiteGuid, cluster_guid: clusterGuid } = urlState;

    const { data: clusters, isLoading } = useFetchUrlClustersQuery(websiteGuid ? { w_guid: websiteGuid } : skipToken);
    const cluster = clusters?.find((c) => c.guid === clusterGuid);

    return (
        <Content className="general-layout-content">
            {!isLoading && cluster && (
                <Header
                    title={
                        <>
                            <div className="main">{cluster?.title}</div>
                            <div className="second">{cluster?.description}</div>
                        </>
                    }
                    rightSideExtra={
                        <UrlClusterHeaderActions
                            websiteGuid={websiteGuid}
                            clusterGuid={clusterGuid}
                        />
                    }
                    showRedirectArrow
                />
            )}
            <DomainSetupCheck
                key={websiteGuid}
                websiteGuid={websiteGuid}
            >
                <ClusterUrls
                    websiteGuid={websiteGuid!}
                    clusterGuid={clusterGuid}
                />

                <ClusterFailedChecks
                    websiteGuid={websiteGuid!}
                    clusterGuid={clusterGuid}
                    urlsInCluster={cluster?.monitored_urls}
                />
            </DomainSetupCheck>
        </Content>
    );
}
